export const photoCaptureAuthenticationRequestReducer = (state, action) => {
    return Object.assign(Object.assign({}, state), { companyCode: action.payload.coCode, contextId: action.payload.contextId });
};
//# sourceMappingURL=photoCaptureAuthenticationRequestReducer.js.map